// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */

import React, { useEffect, useState, useRef } from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import Button from './Button';
import CheckBox from './CheckBox';
import RadioInput from './RadioInput';

interface props {
  startedTime: Date;
  endLabTime?: Date;
  duration: number;
  onTimesUp: () => void;
}

const S = {
  PopMask: styled.div`
    background: #FFFFFF;
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0px;
    top: 0px;
    background: rgba(0, 0, 0, 0.7);
    z-index: 9999;
  `,
  Container: styled.div`
    padding: 20px 80px;
    text-align: center;
  `,
  ChooseDownloadWapper: styled.div`
    background: #FFFFFF;
    border-radius: 11px;
    margin-top: 11px;
    position: fixed;
    font-size: 26px;
    line-height: 38px;
    color: #353535;
    top: 10%;
    left: 50%;
    transform: translate(-51%,0%);
  `,
  ChooseDownloadCard: styled.div<{ visible: boolean }>`
    max-height: ${(props) => props.visible ? '20vw' : '0px'};
    transition: max-height 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    overflow:hidden;
  `,
  CloseBar: styled.div`
    background: #EF8200;
    border-radius: 11px 11px 0px 0px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  `,
  CloseIconContainer: styled.div`
    padding: 0px 17px 4px;
    cursor: pointer;
  `,
  CloseIcon: styled.div`
    display: inline-block;
    width: 14px;
    height: 2px;
    background: #FFF;
    line-height: 0;
    font-size: 0;
    vertical-align: middle;
    transform: rotate(45deg);
    &::after {
      content: "/";
      display: block;
      width: 14px;
      height: 2px;
      background: #FFF;
      transform: rotate(-90deg);
    }
  `,
  ChooseDownloadContent: styled.div`
    margin: 0px 0px 30px 60px;
    display: flex;
    flex-direction: column;
    max-height: 15vw;
    overflow-y: auto;
    & :first-child {
      margin-left: -17px;
      padding-bottom: 8px;
    }
    &::-webkit-scrollbar {
      width: 7px;
    }
    &::-webkit-scrollbar-button {
      background: transparent;
      border-radius: 4px;
    }
    &::-webkit-scrollbar-track-piece {
      background: transparent;
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 4px;
      background-color: #E6E6E6;
      border: 1px solid #E6E6E6;
    }
    &::-webkit-scrollbar-track {
      box-shadow: transparent;
    }
  `,
  ChooseDownloadTitle: styled.p`
    color: #353535;
    font-size: 18px;
    margin-bottom: 15px;
  `,
  SubmitAction: styled.div`
    display: flex;
    justify-content: center;
  `,
  CancelButton: styled(Button)`
    background: #7A7A7A;
    box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.25);
    border-radius: 7px 0px 0px 7px;
    padding: 4px 27px;
    margin-right: 14px;
  `,
  SubmitButton: styled(Button)`
    background: #EF8200;
    box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.25);
    border-radius: 0px 7px 7px 0px;
    padding: 4px 27px;
  `,
  MemberCheckBox: styled(CheckBox)`
    justify-content: flex-start;
    color: #767676;
    padding: 3px 0 3px 20px;
  `,
  MemberCheckBoxText: styled.div`
  `,
  EmptyUserText: styled.div`
    font-size: 18px;
  `,
  TypeChoosedTitle: styled.p`
    color: #353535;
    font-size: 20px;
    text-align: center;
    margin: 0px 0 10px;
  `,
  TypeChoosedContainer: styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 20px;
  `,
  Label: styled.div`
    font-size: 16px;
    line-height: 23px;
    color: #767676;
    margin: 0 15px 0 10px;
    display: flex;
    justify-content: center;
    align-items: center;
  `,
}

const DownloadResultModal = (props: any): JSX.Element => {
  const courseData = props.courseData;
  const setIsChooseDownload = props.setIsChooseDownload;
  const handleDownloadMemberResult = props.handleDownloadMemberResult;
  const handleDownloadCompleteResult = props.handleDownloadCompleteResult;

  const [choosedType, setChoosedType] = useState(false);
  const [isCompleteRate, setIsCompleteRate] = useState(false);
  const [choosedCompleteType, setChoosedCompleteType] = useState(false);
  const [completeRateWithScore, setCompleteRateWithScore] = useState(false);
  const [offsetHeight, setOffsetHeight] = useState(0);
  const choosedHeight = useRef<HTMLDivElement>(null);
  const [choosedUser, setChooseUser] = useState<number[]>([])

  const handleChooseAll = () => {
    const isChooseAll = choosedUser.length === courseData.length;
    if (isChooseAll) {
      setChooseUser([]);
    } else {
      const memberList: number[] = [];
      courseData.forEach((item: any) => {
        memberList.push(item.id);
      })
      setChooseUser(memberList);
    }
  }

  const handleChoose = (item: any) => {
    if (choosedHeight?.current?.scrollHeight) {
      setOffsetHeight(choosedHeight?.current?.scrollTop)
    }
    const currentMemberList = [...choosedUser];
    if (currentMemberList.indexOf(item) > -1) {
      currentMemberList.splice(currentMemberList.indexOf(item), 1);
    } else {
      currentMemberList.push(item);
    }
    setChooseUser(currentMemberList);
  }

  const handleDownload = async () => {
    if (isCompleteRate) {
      setChoosedCompleteType(false);
      await handleDownloadCompleteResult(completeRateWithScore);
    } else {
      setChooseUser([]);
      await handleDownloadMemberResult(choosedUser);
    }
    setChoosedType(false);
  }

  const closeModal = () => {
    setIsChooseDownload(false);
    setChooseUser([]);
  }

  const memberChoosedList = (visible: boolean) => {
    return (
      <S.ChooseDownloadCard visible={visible}>
        <S.ChooseDownloadTitle>
          <FormattedMessage id="D033" />
        </S.ChooseDownloadTitle>
        <S.ChooseDownloadContent ref={choosedHeight}>
          { courseData.length === 0 ? (
            <S.EmptyUserText>
              <FormattedMessage id="D038" />
            </S.EmptyUserText>
          ) : (
            <S.MemberCheckBox onChange={() => handleChooseAll()} value={0} checked={choosedUser.length === courseData.length}>
              <S.MemberCheckBoxText>
                <FormattedMessage id="D036" />
              </S.MemberCheckBoxText>
            </S.MemberCheckBox>
          )}
          { courseData.map((item: any, index: number) => {
            return (
              <S.MemberCheckBox key={index} onChange={() => handleChoose(item.id)} value={item.id} checked={choosedUser.indexOf(item.id) > -1}>
                <S.MemberCheckBoxText>
                  { item.email }
                </S.MemberCheckBoxText>
              </S.MemberCheckBox>
            )
          })}
        </S.ChooseDownloadContent>
      </S.ChooseDownloadCard>
    )
  }

  const completeChoosedSection = (visible: boolean) => {
    return (
      <S.ChooseDownloadCard visible={visible}>
        <S.ChooseDownloadTitle>
          <FormattedMessage id="D042" />
        </S.ChooseDownloadTitle>
        <S.TypeChoosedContainer>
          <RadioInput
            onClick={() => { setCompleteRateWithScore(false); setChoosedCompleteType(true) }}
            checked={!completeRateWithScore && choosedCompleteType}
            id={'completeRateOnly'}
            label={'completeRateOnly'}
            customLabel={() => <S.Label><FormattedMessage id="D043" /></S.Label>}
          />
          <RadioInput
            onClick={() => { setCompleteRateWithScore(true); setChoosedCompleteType(true) }}
            checked={completeRateWithScore && choosedCompleteType}
            id={'completeRateWithScore'}
            label={'completeRateWithScore'}
            customLabel={() => <S.Label><FormattedMessage id="D044" values={{br: <br/>}}/></S.Label>}
          />
        </S.TypeChoosedContainer>
      </S.ChooseDownloadCard>
    )
  }

  useEffect(() => {
    if (choosedHeight?.current) {
      choosedHeight?.current?.scrollTo(0, offsetHeight)
    }
  }, [offsetHeight])

  return (
    <>
      <S.PopMask>
        <S.ChooseDownloadWapper>
          <S.CloseBar>
            <S.CloseIconContainer onClick={() => { closeModal() }}><S.CloseIcon/></S.CloseIconContainer>
          </S.CloseBar>
          <S.Container>
            <S.TypeChoosedTitle><FormattedMessage id="D039" /></S.TypeChoosedTitle>
            <S.TypeChoosedContainer>
              <RadioInput
                onClick={() => { setIsCompleteRate(true); setChoosedType(true) }}
                checked={isCompleteRate && choosedType}
                id={'completeRate'}
                label={'completeRate'}
                customLabel={() => <S.Label><FormattedMessage id="D040" /></S.Label>}
              />
              <RadioInput
                onClick={() => { setIsCompleteRate(false); setChoosedType(true) }}
                checked={!isCompleteRate && choosedType}
                id={'memberResult'}
                label={'memberResult'}
                customLabel={() => <S.Label><FormattedMessage id="D041" /></S.Label>}
              />
            </S.TypeChoosedContainer>
            { memberChoosedList(choosedType && !isCompleteRate) }
            { completeChoosedSection(choosedType && isCompleteRate) }
            <S.SubmitAction>
              <S.CancelButton onClick={() => { closeModal() }}><FormattedMessage id="E065" /></S.CancelButton>
              <S.SubmitButton disabled={!choosedCompleteType && choosedUser.length === 0} onClick={() => {
                if (courseData.length === 0) {
                  closeModal()
                } else {
                  handleDownload()
                }
              }}>
                <FormattedMessage id="D034" />
              </S.SubmitButton>
            </S.SubmitAction>
          </S.Container>
        </S.ChooseDownloadWapper>
      </S.PopMask>
    </>
  )
}

export default DownloadResultModal;
